import React from 'react';
import {Row, Col} from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';

// const category = ['qna', 'musio', 'extra'];


export const Description =()=>{
  return(
    <Row className="title">
      <Col xs={12} className="text-center">
        <span className="main">
          新しいスレッド
        </span>
        <span className="sub">
          内容を入力して、コミュニティに投稿します。
        </span>
      </Col>
    </Row>
  );
};

//if width of the photo is larger than the width of texteditor, set width to 100%
//otherwise, set the width to auto. set height to auto always
const TextEditor = ({handlers})=>{
  return(
    <Editor
      wrapperClassName="wrapper-class"
      editorClassName="editor-class"
      toolbarClassName="toolbar-class"
      toolbar={{
        options: ['inline','blockType','fontSize', 'list', 'textAlign','link','emoji','image'],
        image:{
          urlEnabled: false,
          uploadEnabled: true,
          uploadCallback: handlers.imageHandler,
          inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
        }
      }}
      onEditorStateChange = {handlers.onEditorStateChange}
    />
  )
}


export const ThreadPost = ({handlers, state}) =>{
  return(
    <Row className="post-container">
      <Col xs={12} sm={8} smOffset={2}>
        <div className="thread-info">
          <input className="input_author" name="author"
            placeholder="名前(オプション)" onChange={handlers.onInfoChange} />
          <input className="input_title" name="title"
            placeholder="タイトル" onChange={handlers.onInfoChange} />
        </div>
        <TextEditor handlers={handlers} />
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/Support.Forum.Post.js